export class AuthSessionExpiredError extends Error {
  constructor(message = 'Your Pulse session has expired. Sign in again to continue.') {
    super(message)
    this.name = 'AuthSessionExpiredError'
  }
}

export function isAuthSessionExpiredError(error: unknown): error is AuthSessionExpiredError {
  return error instanceof AuthSessionExpiredError
}
